
export function removeFirstNumbersString(name?: string | null) {
	if (!name) {
		return '';
	}

	const splitName = name.split(' ');
	// If there is only one element, it means that there is no number in the name
	if (splitName.length === 1) {
		return name;
	}

	// Check if first element contains numbers
	if (/\d/.test(splitName[0])) {
		// If it does, remove it
		splitName.shift(); // remove first element
	}

	// Join back all strings
	const joinedRest = splitName.join(' ');

	return joinedRest;
}
